export default __webpack_public_path__ + "static/media/FranklinTempleton.5571ddaa.png";